const IntegrationNotFound = () => {
    return (
        <div>Integration Not Found</div>
    )
}

export default IntegrationNotFound
